/**
 * Allowed reasons when cancelling a charter (trip).
 * Keep in sync with server constants/charterCancellationReasons.js
 */
export const CHARTER_CANCELLATION_REASONS = [
  'Defect',
  'Crew',
  'Cancelled by guest',
  'Weather',
  'Other'
];
